import styles from './FileUpload.module.scss';
import { CSV } from '../../assets/images/CSV';
import { Error, Plus, Refresh, Typography } from '@weareopenr/component-library';
import { formatFileSize } from '../../helpers/formatFileSize/formatFileSize';

interface IFileUploadProps {
  file: File | null;
  setFile: (file: File | null) => void;
  prompt: string;
  acceptedTypes: string;
  error?: string;
}
export const FileUpload = ({ file, setFile, prompt, acceptedTypes, error }: IFileUploadProps) => {
  const inputId = 'file-upload';
  return (
    <>
      {file ? (
        <div className={styles['file-upload-preview']}>
          <div className={styles['file-info']}>
            {error ? (
              <>
                <Error className={styles['error-icon']} />
                <Typography size="large" weight="bold" className={styles['error-text']}>
                  Error uploading file
                </Typography>
              </>
            ) : (
              <>
                <CSV />
                <Typography className={styles['file-name']}>{file.name}</Typography>
              </>
            )}
            <Typography className={styles['subtitle']} size="xsmall">
              {error ? error : formatFileSize(file.size)}
            </Typography>
          </div>
          <label htmlFor={inputId} className={styles['replace-button']}>
            <Refresh />
            <Typography>Replace</Typography>
          </label>
        </div>
      ) : (
        <label htmlFor={inputId}>
          <div className={styles['file-upload-container']}>
            <Plus />
            <Typography className={styles['blueberry']}>{prompt}</Typography>
          </div>
        </label>
      )}

      <input id={inputId} hidden type="file" accept={acceptedTypes} onChange={(e) => setFile(e.target.files?.[0])} />
    </>
  );
};
